import React from 'react';
import { Link } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
    button: {
        marginTop: '10px'
    }
};


const AddRoleButton = ({ classes, record, id }) => (
    <Button
        variant="contained"
        component={Link}
        to={`/role/create/${id}/`}
        label="Add Role"
        className={classes.button}
    >
        <AddCircleOutlineIcon />
    </Button>
);

export default withStyles(styles)(AddRoleButton);